


































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';
import IAuthentication from '@/store/models/IAuthentication';
import IRolePermission from '@/store/models/IRolePermission';
import InboundsNoticeOfLossSelector from '@/components/selectors/NoticeOfLoss/InboundsNoticeOfLossSelector.vue';
import InboundsDeliveryNoteNoticeOfLossSelector from '@/components/selectors/NoticeOfLoss/InboundsDeliveryNoteNoticeOfLossSelector.vue';
import InboundsDeliveryNoteNoticeOfLossPictures from '@/components/selectors/NoticeOfLoss/InboundsDeliveryNoteNoticeOfLossPictures.vue';
import IInbound from '@/store/models/IInbound';
import InboundApi from '../store/api/InboundApi';
import OutboundsNoticeOfLossSelector from '@/components/selectors/NoticeOfLoss/OutboundsNoticeOfLossSelector.vue';
import OutboundsDeliveryNoteNoticeOfLossSelector from '@/components/selectors/NoticeOfLoss/OutboundsDeliveryNoteNoticeOfLossSelector.vue';
import OutboundsDeliveryNoteNoticeOfLossPictures from '@/components/selectors/NoticeOfLoss/OutboundsDeliveryNoteNoticeOfLossPictures.vue';
import IOutbound from '@/store/models/IOutbound';
import OutboundApi from '../store/api/OutboundApi';
import OutboundDeliveryNotesApi from '@/store/api/OutboundDeliveryNotesApi';
import IOutboundDeliveryNotes from '@/store/models/IOutboundDeliveryNotes';
import OutboundsNoticeOfLossApi from '@/store/api/OutboundsNoticeOfLossApi';
import IOutboundDeliveryNotesDetail from '@/store/models/IOutboundDeliveryNotesDetail';
import InboundDeliveryNotesApi from '@/store/api/InboundDeliveryNotesApi';
import IInboundDeliveryNotes from '@/store/models/IInboundDeliveryNotes';
import InboundsNoticeOfLossApi from '@/store/api/InboundsNoticeOfLossApi';
import IInboundDeliveryNotesDetail from '@/store/models/IInboundDeliveryNotesDetail';
import INoticeOfLoss from '@/store/models/INoticeOfLoss';
import INoticeOfLossDetail from '@/store/models/INoticeOfLossDetail';
import OutboundsNoticeOfLossDetailApi from '@/store/api/OutboundsNoticeOfLossDetailApi';
import OutboundDeliveryNotesDetailApi from '@/store/api/OutboundDeliveryNotesDetailApi';
import InboundsNoticeOfLossDetailApi from '@/store/api/InboundsNoticeOfLossDetailApi';
import InboundDeliveryNotesDetailApi from '@/store/api/InboundDeliveryNotesDetailApi';
import INoticeOfLossPictures from '@/store/models/INoticeOfLossPictures';
import OutboundNoticeOfLossPicturesApi from '@/store/api/OutboundsNoticeOfLossPicturesApi';
import InboundNoticeOfLossPicturesApi from '@/store/api/InboundsNoticeOfLossPicturesApi';
import UploadServiceApi from '../store/api/UploadServiceApi';
import IBlob from '@/store/models/IBlob';
import IStock from '@/store/models/IStock';
import StockApi from '@/store/api/StockApi';
import DataManagementApi from '@/store/api/DataManagementApi';
import CustomerApi from '@/store/api/CustomerApi';
import ICustomer from '@/store/models/ICustomer';
import SettingsCompanyApi from '@/store/api/SettingsCompanyApi';
import ISettingsCompany from '@/store/models/ISettingsCompany';
import { SettingsCompany } from '@/components/shared/SettingsCompany';
@Component({
    components: {
        Snackbar,
        InboundsNoticeOfLossSelector,
        OutboundsNoticeOfLossSelector,
        InboundsDeliveryNoteNoticeOfLossSelector,
        InboundsDeliveryNoteNoticeOfLossPictures,
        OutboundsDeliveryNoteNoticeOfLossSelector,
        OutboundsDeliveryNoteNoticeOfLossPictures
    }
})
export default class NoticeOfLoss extends Vue {
    activeTab : number = 0;
    enableTabsItemNoticeOfLossInbounds: boolean = false;
    enableTabsItemNoticeOfLossPicturesInbounds: boolean = false;
    enableTabsItemNoticeOfLossOutbounds: boolean = false;
    enableTabsItemNoticeOfLossPicturesOutbounds: boolean = false;
    permissions : IRolePermission[] = [];
    idCompany: string = "";
    InboundList : IInbound[] = [];
    inboundApi : InboundApi;
    OutboundList : IOutbound[] = [];
    outboundApi : OutboundApi;
    OutboundDeliveryNotesList : IOutboundDeliveryNotes[] = [];
    outboundDeliveryNotesApi : OutboundDeliveryNotesApi;
    OutboundNoticeOfLossList : INoticeOfLoss[] = [];
    outboundNoticeOfLossApi : OutboundsNoticeOfLossApi;
    OutboundNoticeOfLossDetailList : INoticeOfLossDetail[] = [];
    outboundNoticeOfLossDetailApi : OutboundsNoticeOfLossDetailApi;
    OutboundDeliveryNotesDetailList : IOutboundDeliveryNotesDetail[] = [];
    outboundDeliveryNotesDetailApi : OutboundDeliveryNotesDetailApi;
    selectedOutboundDeliveryNote : IOutboundDeliveryNotes[] = [];
    selectedOutbound : IOutbound = {} as IOutbound;
    outboundsSelectedNoticeOfLoss : INoticeOfLoss | null = null;
    outboundNoticeOfLossPictureApi : OutboundNoticeOfLossPicturesApi;
    OutboundNoticeOfLossPictures : INoticeOfLossPictures[] = [];
    InboundDeliveryNotesList : IInboundDeliveryNotes[] = [];
    inboundDeliveryNotesApi : InboundDeliveryNotesApi;
    InboundNoticeOfLossList : INoticeOfLoss[] = [];
    inboundNoticeOfLossApi : InboundsNoticeOfLossApi;
    InboundNoticeOfLossDetailList : INoticeOfLossDetail[] = [];
    inboundNoticeOfLossDetailApi : InboundsNoticeOfLossDetailApi;
    InboundDeliveryNotesDetailList : IInboundDeliveryNotesDetail[] = [];
    inboundDeliveryNotesDetailApi : InboundDeliveryNotesDetailApi;
    selectedInboundDeliveryNote : IInboundDeliveryNotes[] = [];
    selectedInbound : IInbound = {} as IInbound;
    inboundsSelectedNoticeOfLoss : INoticeOfLoss | null = null;
    inboundNoticeOfLossPictureApi : InboundNoticeOfLossPicturesApi;
    InboundNoticeOfLossPictures : INoticeOfLossPictures[] = [];
    uploadServiceApi : UploadServiceApi;
    OutboundsBlobsSource : IBlob[] = [];
    InboundsBlobsSource : IBlob[] = [];
    stockApi: StockApi;
    customerStockDeliveryNoteDetail : IStock[] = [];
    dataManagementApi : DataManagementApi;
    outboundDeliveryNotesSelected : IOutboundDeliveryNotes[] = [];
    inboundDeliveryNotesSelected : IInboundDeliveryNotes[] = [];
    overlay: boolean = false;
    LoadingOverlay: boolean = false;
    showCustomer: boolean = false;
    customersApi : CustomerApi;
    CustomerList : ICustomer[] = [];
    settingsCompanyApi : SettingsCompanyApi;
    constructor() {
        super();
        this.inboundApi = new InboundApi();
        this.outboundApi = new OutboundApi();
        this.outboundDeliveryNotesApi = new OutboundDeliveryNotesApi();
        this.outboundDeliveryNotesDetailApi = new OutboundDeliveryNotesDetailApi();
        this.outboundNoticeOfLossApi = new OutboundsNoticeOfLossApi();
        this.outboundNoticeOfLossDetailApi = new OutboundsNoticeOfLossDetailApi();
        this.outboundNoticeOfLossPictureApi = new OutboundNoticeOfLossPicturesApi();
        this.inboundDeliveryNotesApi = new InboundDeliveryNotesApi();
        this.inboundDeliveryNotesDetailApi = new InboundDeliveryNotesDetailApi();
        this.inboundNoticeOfLossApi = new InboundsNoticeOfLossApi();
        this.inboundNoticeOfLossDetailApi = new InboundsNoticeOfLossDetailApi();
        this.inboundNoticeOfLossPictureApi = new InboundNoticeOfLossPicturesApi();
        this.uploadServiceApi = new UploadServiceApi("Movements");
        this.stockApi = new StockApi();
        this.dataManagementApi = new DataManagementApi();
        this.customersApi = new CustomerApi();
        this.settingsCompanyApi = new SettingsCompanyApi("Movements");
    }

    created() {
        this.getPermissions();
        this.getInbounds();
        this.getOutbounds();
        this.getCustomers();
    }

    async getCustomers() {
        this.CustomerList = await this.customersApi.GetCustomersByCompanyId(this.idCompany);
    }
    async onChangeOutbound(outbound: IOutbound) {
        this.selectedOutbound = outbound;
        if (this.selectedOutbound) {
            this.OutboundDeliveryNotesList = await this.outboundDeliveryNotesApi.GetOutboundDeliveryNotes(this.selectedOutbound.id);
        }
    }

    get WarehouseNameInboundDeliveryNotesSelected() {
        if (this.inboundDeliveryNotesSelected.length > 0) {
            return this.inboundDeliveryNotesSelected[0].warehouseName;
        }
        return "";
    }

    get WarehouseNameOutboundDeliveryNotesSelected() {
        if (this.outboundDeliveryNotesSelected.length > 0) {
            return this.outboundDeliveryNotesSelected[0].warehouseName;
        }
        return "";
    }

    async onChangeOutboundsSelectedNoticeOfLoss(noticeOfLoss :INoticeOfLoss[]) {
        if (noticeOfLoss.length > 0) {
            this.enableTabsItemNoticeOfLossPicturesOutbounds = true;
            this.OutboundNoticeOfLossDetailList = await this.outboundNoticeOfLossDetailApi.GetOutboundsNoticeOfLossDetail(noticeOfLoss[0].id);
            this.OutboundNoticeOfLossPictures = await this.outboundNoticeOfLossPictureApi.GetOutboundsNoticeOfLossPictures(noticeOfLoss[0].id);
        } else {
            this.enableTabsItemNoticeOfLossPicturesOutbounds = false;
            this.OutboundNoticeOfLossDetailList = [];
            this.OutboundNoticeOfLossPictures = [];
            this.OutboundsBlobsSource = [];
        }
    }

    get OutboundsBlobsFiltered() {
        if (this.OutboundsBlobsSource.length > 0) {
            if (this.outboundsSelectedNoticeOfLoss) {
                return this.OutboundsBlobsSource.filter(b => b.noticeOfLossId === this.outboundsSelectedNoticeOfLoss!.id);
            }
        }
        return [];
    }

    async onChangeSelectedOutboundDeliveryNotes(outboundDeliveryNotes : IOutboundDeliveryNotes[]) {
        if (outboundDeliveryNotes.length > 0) {
            this.enableTabsItemNoticeOfLossOutbounds = true;
            this.outboundDeliveryNotesSelected = outboundDeliveryNotes;
            this.selectedOutboundDeliveryNote = outboundDeliveryNotes;
            this.OutboundNoticeOfLossList = await this.outboundNoticeOfLossApi.GetOutboundsNoticeOfLoss(outboundDeliveryNotes[0].id);
        } else {
            this.enableTabsItemNoticeOfLossOutbounds = false;
            this.OutboundNoticeOfLossList = [];
            this.outboundDeliveryNotesSelected = [];
        }
    }

    async getOutboundDeliveryNotesDetails() {
        if (this.selectedOutboundDeliveryNote.length > 0) {
            this.OutboundDeliveryNotesDetailList = await this.outboundDeliveryNotesDetailApi.GetOutboundDeliveryNotesDetail(this.selectedOutboundDeliveryNote[0].id);
        }
    }

    async onChangeInbound(inbounds: IInbound[]) {
    // Guardar “seleccionado” (primero del array) sin ?. ni ??
        if (Array.isArray(inbounds) && inbounds.length > 0) {
            this.selectedInbound = inbounds[0];
        } else {
            this.selectedInbound = {} as IInbound;
            this.InboundDeliveryNotesList = [];
            return;
        }

        // Llamadas en paralelo
        const results = await Promise.all(
            inbounds.map((inb: IInbound) => this.inboundDeliveryNotesApi.GetInboundDeliveryNotes(inb.id))
        );

        // Aplanar resultados sin .flat() (por si tampoco lo soporta)
        const all: any[] = [];
        results.forEach((list: any[]) => {
            if (Array.isArray(list)) all.push(...list);
        });

        this.InboundDeliveryNotesList = all;

        // Lógica de ocultar customer igual que antes
        if (this.showCustomer === false) {
            this.InboundDeliveryNotesList.forEach((i: any) => {
                const indexCustomer = this.CustomerList.findIndex((c: any) => c.id === i.idCustomer);
                if (indexCustomer !== -1) {
                    if (
                        i.idCompanyDestination !== this.CustomerList[indexCustomer].idCompany &&
                    this.idCompany !== i.idCompanySource
                    ) {
                        i.customerName = "";
                    }
                } else {
                    i.customerName = "";
                }
            });
        }
    }

    async onChangeInboundsSelectedNoticeOfLoss(noticeOfLoss :INoticeOfLoss[]) {
        if (noticeOfLoss.length > 0) {
            this.enableTabsItemNoticeOfLossPicturesInbounds = true;
            this.InboundNoticeOfLossDetailList = await this.inboundNoticeOfLossDetailApi.GetInboundsNoticeOfLossDetail(noticeOfLoss[0].id);
            this.InboundNoticeOfLossPictures = await this.inboundNoticeOfLossPictureApi.GetInboundsNoticeOfLossPictures(noticeOfLoss[0].id);
        } else {
            this.enableTabsItemNoticeOfLossPicturesInbounds = false;
            this.InboundNoticeOfLossDetailList = [];
            this.InboundNoticeOfLossPictures = [];
            this.InboundsBlobsSource = [];
        }
    }

    get InboundsBlobsFiltered() {
        if (this.InboundsBlobsSource.length > 0) {
            if (this.inboundsSelectedNoticeOfLoss) {
                return this.InboundsBlobsSource.filter(b => b.noticeOfLossId === this.inboundsSelectedNoticeOfLoss!.id);
            }
        }
        return [];
    }

    async onChangeSelectedInboundDeliveryNotes(inboundDeliveryNotes : IInboundDeliveryNotes[]) {
        if (inboundDeliveryNotes.length > 0) {
            this.enableTabsItemNoticeOfLossInbounds = true;
            this.inboundDeliveryNotesSelected = inboundDeliveryNotes;
            this.selectedInboundDeliveryNote = inboundDeliveryNotes;
            this.InboundNoticeOfLossList = await this.inboundNoticeOfLossApi.GetInboundsNoticeOfLoss(inboundDeliveryNotes[0].id);
        } else {
            this.enableTabsItemNoticeOfLossInbounds = false;
            this.InboundNoticeOfLossList = [];
            this.inboundDeliveryNotesSelected = [];
        }
    }

    async getInboundDeliveryNotesDetails() {
        if (this.selectedInboundDeliveryNote.length > 0) {
            this.InboundDeliveryNotesDetailList = [];
            let inboundDeliveryNotesDetailList = await this.inboundDeliveryNotesDetailApi.GetInboundDeliveryNotesDetailByIdInboundDeliveryNote(this.selectedInboundDeliveryNote[0].id);
            let idGoods : string[] = inboundDeliveryNotesDetailList.map(g => g.idGood);
            let idInboundsDeliveryNoteDetails : string[] = inboundDeliveryNotesDetailList.map(g => g.id);
            this.customerStockDeliveryNoteDetail = await this.stockApi.GetStockGroupByGoods(idGoods, idInboundsDeliveryNoteDetails);
            this.customerStockDeliveryNoteDetail = this.customerStockDeliveryNoteDetail.filter(c => c.idWarehouse === this.selectedInboundDeliveryNote[0].idWarehouse);
            this.customerStockDeliveryNoteDetail.forEach(c => {
                let inboundDeliveryNotesDetail : IInboundDeliveryNotesDetail = {} as IInboundDeliveryNotesDetail;
                inboundDeliveryNotesDetail.id = c.idInboundDeliveryNoteDetail;
                inboundDeliveryNotesDetail.idGood = c.idGood;
                inboundDeliveryNotesDetail.goodName = c.goodName;
                inboundDeliveryNotesDetail.idPallet = c.idPallet;
                inboundDeliveryNotesDetail.idListPallet = c.idListPallet;
                inboundDeliveryNotesDetail.palletName = c.listPalletName;
                inboundDeliveryNotesDetail.casesPerPallet = c.totalCases;
                inboundDeliveryNotesDetail.totalCases = c.totalCases;
                inboundDeliveryNotesDetail.goodsPerCase = c.goodsPerCase;
                inboundDeliveryNotesDetail.totalGoods = c.totalGoods;
                inboundDeliveryNotesDetail.bestBeforeDate = c.bestBeforeDate;
                inboundDeliveryNotesDetail.idInboundDeliveryNote = c.idInboundDeliveryNoteDetail;
                this.InboundDeliveryNotesDetailList.push(inboundDeliveryNotesDetail);
            });
        }
    }

    async getInbounds() {
        this.InboundList = await this.inboundApi.GetInboundsCodes(this.idCompany);
    }
    
    async getOutbounds() {
        this.OutboundList = await this.outboundApi.GetOutboundsCodes(this.idCompany);
    }

    async getPermissions() {
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idCompany = userFromStorage.idCompany;
        this.permissions.push(userFromStorage.rolePermissions.find(r => r.formName === "Users"));
        let settingsCompany = SettingsCompany.Settings.ShowCustomer;
        let setting : ISettingsCompany[] = await this.settingsCompanyApi.getSettingCompanyId(this.idCompany, settingsCompany);
        if (setting.length > 0) {
            if (setting[0].value === "No") {
                this.showCustomer = false;
            } else {
                this.showCustomer = true;
            }
        }
    }

    async saveOutboundNoticeOfLoss(noticeOfLoss: INoticeOfLoss) {
        this.overlay = true;
        noticeOfLoss.idDeliveryNote = this.selectedOutboundDeliveryNote[0].id;
        noticeOfLoss.idWarehouse = this.selectedOutboundDeliveryNote[0].idWarehouse;
        const id = await this.outboundNoticeOfLossApi.SaveOutboundsNoticeOfLoss(noticeOfLoss);
        if (id) {
            noticeOfLoss.id = id;
            this.OutboundNoticeOfLossList = [noticeOfLoss].concat(this.OutboundNoticeOfLossList);
            this.outboundsSelectedNoticeOfLoss = noticeOfLoss;
            this.showMessageInfo(`The notice of loss has been successfully saved`);
        } else {
            const errors: string = this.outboundNoticeOfLossApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async editOutboundNoticeOfLoss(noticeOfLoss: INoticeOfLoss) {
        this.overlay = true;
        let result : boolean = await this.outboundNoticeOfLossApi.UpdateOutboundsNoticeOfLoss(noticeOfLoss);
        if (result) {
            this.showMessageInfo(`The notice of loss has been successfully edited`);
        } else {
            const errors: string = this.outboundNoticeOfLossApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async saveInboundNoticeOfLoss(noticeOfLoss: INoticeOfLoss) {
        this.overlay = true;
        noticeOfLoss.idDeliveryNote = this.selectedInboundDeliveryNote[0].id;
        noticeOfLoss.idWarehouse = this.selectedInboundDeliveryNote[0].idWarehouse;
        const id = await this.inboundNoticeOfLossApi.SaveInboundsNoticeOfLoss(noticeOfLoss);
        if (id) {
            noticeOfLoss.id = id;
            this.InboundNoticeOfLossList = [noticeOfLoss].concat(this.InboundNoticeOfLossList);
            this.inboundsSelectedNoticeOfLoss = noticeOfLoss;
            this.showMessageInfo(`The notice of loss has been successfully saved`);
        } else {
            const errors: string = this.inboundNoticeOfLossApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async editInboundNoticeOfLoss(noticeOfLoss: INoticeOfLoss) {
        this.overlay = true;
        let result : boolean = await this.inboundNoticeOfLossApi.UpdateInboundsNoticeOfLoss(noticeOfLoss);
        if (result) {
            this.showMessageInfo(`The notice of loss has been successfully edited`);
        } else {
            const errors: string = this.inboundNoticeOfLossApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    deleteOutboundNoticeOfLoss(item: INoticeOfLoss) {
        confirm('Are you sure you want to delete this notice of loss?') && this.deleteOutboundsNoticeOfLossItem(item);
    }

    async deleteOutboundsNoticeOfLossItem(noticeOfLoss: INoticeOfLoss) {
        this.overlay = true;
        let resultDeleteImages = await this.outboundNoticeOfLossPictureApi.DeleteNoticeOfLossPicturesByNoticeOfLossId(noticeOfLoss.id);
        if (this.OutboundNoticeOfLossDetailList.length > 0) {
            this.OutboundNoticeOfLossDetailList.forEach(async i => {
                await this.outboundNoticeOfLossDetailApi.DeleteOutboundsNoticeOfLossDetail(i.id);
            });
        }
        let result: boolean = await this.outboundNoticeOfLossApi.DeleteOutboundsNoticeOfLoss(noticeOfLoss.id);
        if (result) {
            const index = this.OutboundNoticeOfLossList.indexOf(noticeOfLoss);
            this.OutboundNoticeOfLossList.splice(index, 1);
            this.showMessageInfo(`The notice of loss has been successfully deleted`);
        } else {
            const errors: string = this.outboundNoticeOfLossApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async saveOutboundNoticeOfLossDetail(noticeOfLossDetail: INoticeOfLossDetail[]) {
        noticeOfLossDetail.forEach(async n => {
            this.LoadingOverlay = true;
            const id = await this.outboundNoticeOfLossDetailApi.SaveOutboundsNoticeOfLossDetail(n);
            if (id) {
                n.id = id;
                this.OutboundNoticeOfLossDetailList = [n].concat(this.OutboundNoticeOfLossDetailList);
                this.showMessageInfo(`The notice of loss detail has been successfully saved`);
            } else {
                const errors: string = this.outboundNoticeOfLossDetailApi.getModelError().join("; ");
                this.showMessageError(errors);
            }
            this.LoadingOverlay = false;
        });
    }

    async editOutboundNoticeOfLossDetail(noticeOfLossDetail: INoticeOfLossDetail) {
        this.overlay = true;
        let result : boolean = await this.outboundNoticeOfLossDetailApi.UpdateOutboundsNoticeOfLossDetail(noticeOfLossDetail);
        if (result) {
            this.showMessageInfo(`The notice of loss detail has been successfully edited`);
        } else {
            const errors: string = this.outboundNoticeOfLossDetailApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    deleteInboundNoticeOfLoss(item: INoticeOfLoss) {
        confirm('Are you sure you want to delete this notice of loss?') && this.deleteInboundsNoticeOfLossItem(item);
    }

    async deleteInboundsNoticeOfLossItem(noticeOfLoss: INoticeOfLoss) {
        this.overlay = true;
        let resultDeleteImages = await this.inboundNoticeOfLossPictureApi.DeleteNoticeOfLossPicturesByNoticeOfLossId(noticeOfLoss.id);
        if (this.InboundNoticeOfLossDetailList.length > 0) {
            this.InboundNoticeOfLossDetailList.forEach(async i => {
                await this.inboundNoticeOfLossDetailApi.DeleteInboundsNoticeOfLossDetail(i.id);
            });
        }
        let result: boolean = await this.inboundNoticeOfLossApi.DeleteInboundsNoticeOfLoss(noticeOfLoss.id);
        if (result) {
            const index = this.InboundNoticeOfLossList.indexOf(noticeOfLoss);
            this.InboundNoticeOfLossList.splice(index, 1);
            this.showMessageInfo(`The notice of loss has been successfully deleted`);
        } else {
            const errors: string = this.inboundNoticeOfLossApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async saveInboundNoticeOfLossDetail(noticeOfLossDetail: INoticeOfLossDetail[]) {
        noticeOfLossDetail.forEach(async n => {
            this.LoadingOverlay = true;
            const id = await this.inboundNoticeOfLossDetailApi.SaveInboundsNoticeOfLossDetail(n);
            if (id) {
                n.id = id;
                this.InboundNoticeOfLossDetailList = [n].concat(this.InboundNoticeOfLossDetailList);
                this.showMessageInfo(`The notice of loss detail has been successfully saved`);
            } else {
                const errors: string = this.inboundNoticeOfLossDetailApi.getModelError().join("; ");
                this.showMessageError(errors);
            }
            this.LoadingOverlay = false;
        });
    }

    async editInboundNoticeOfLossDetail(noticeOfLossDetail: INoticeOfLossDetail) {
        this.overlay = true;
        let result : boolean = await this.inboundNoticeOfLossDetailApi.UpdateInboundsNoticeOfLossDetail(noticeOfLossDetail);
        if (result) {
            this.showMessageInfo(`The notice of loss detail has been successfully edited`);
        } else {
            const errors: string = this.inboundNoticeOfLossDetailApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    deleteOutboundNoticeOfLossDetail(item: INoticeOfLossDetail) {
        confirm('Are you sure you want to delete this notice of loss detail?') && this.deleteOutboundsNoticeOfLossDetailItem(item);
    }

    async deleteOutboundsNoticeOfLossDetailItem(noticeOfLossDetail: INoticeOfLossDetail) {
        this.overlay = true;
        let result: boolean = await this.outboundNoticeOfLossDetailApi.DeleteOutboundsNoticeOfLossDetail(noticeOfLossDetail.id);
        if (result) {
            const index = this.OutboundNoticeOfLossDetailList.indexOf(noticeOfLossDetail);
            this.OutboundNoticeOfLossDetailList.splice(index, 1);
            this.showMessageInfo(`The notice of loss detail has been successfully deleted`);
        } else {
            const errors: string = this.outboundNoticeOfLossDetailApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    deleteInboundNoticeOfLossDetail(item: INoticeOfLossDetail) {
        confirm('Are you sure you want to delete this notice of loss detail?') && this.deleteInboundsNoticeOfLossDetailItem(item);
    }

    async deleteInboundsNoticeOfLossDetailItem(noticeOfLossDetail: INoticeOfLossDetail) {
        this.overlay = true;
        let result: boolean = await this.inboundNoticeOfLossDetailApi.DeleteInboundsNoticeOfLossDetail(noticeOfLossDetail.id);
        if (result) {
            const index = this.InboundNoticeOfLossDetailList.indexOf(noticeOfLossDetail);
            this.InboundNoticeOfLossDetailList.splice(index, 1);
            this.showMessageInfo(`The notice of loss detail has been successfully deleted`);
        } else {
            const errors: string = this.inboundNoticeOfLossDetailApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }
    
    deleteOutboundsNoticeOfLossPicture (item: INoticeOfLossPictures) {
        confirm('Are you sure you want to delete this notice of loss Picture?') && this.deleteOutboundsNoticeOfLossPictureItem(item);
    }

    async deleteOutboundsNoticeOfLossPictureItem(outboundNoticeOfLossPicture: INoticeOfLossPictures) {
        this.overlay = true;
        let result: boolean = await this.outboundNoticeOfLossPictureApi.DeleteNoticeOfLossPictures(outboundNoticeOfLossPicture.id);
        if (result) {
            let index = this.OutboundNoticeOfLossPictures.indexOf(outboundNoticeOfLossPicture);
            this.OutboundNoticeOfLossPictures.splice(index, 1);
            let pictureIndex = this.OutboundsBlobsSource.findIndex(p => p.url === outboundNoticeOfLossPicture.url);
            this.OutboundsBlobsSource.splice(pictureIndex, 1);
            this.showMessageInfo(`The outbound Picture has been successfully deleted`);
        } else {
            const errors: string = this.outboundNoticeOfLossPictureApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async uploadOutboundNoticeOfLossPicture(formData : FormData) {
        this.overlay = true;
        let urls: string[] = await this.uploadServiceApi.UploadDocuments(formData);
        for (let i in urls) {
            let outboundNoticeOfLossPicture: INoticeOfLossPictures = {
                id: "",
                url: urls[i],
                urlBlob: "",
                idNoticeOfLoss: this.outboundsSelectedNoticeOfLoss!.id
            };
            const id = await this.outboundNoticeOfLossPictureApi.SaveOutboundsNoticeOfLossPictures(outboundNoticeOfLossPicture);
            if (id) {
                outboundNoticeOfLossPicture.id = id;
                outboundNoticeOfLossPicture.urlBlob = await this.uploadServiceApi.DownloadPictures(outboundNoticeOfLossPicture.url);
                this.OutboundNoticeOfLossPictures.push(outboundNoticeOfLossPicture);
            } else {
                const errors: string = this.outboundNoticeOfLossPictureApi.getModelError().join("; ");
                this.showMessageError(errors);
            }
        }
        this.showMessageInfo(`The outbound pictures has been successfully saved`);
        this.overlay = false;
    }

    downloadOutboundNoticeOfLossPicture(noticeOfLossPicture : INoticeOfLossPictures) {
        this.overlay = true;
        this.uploadServiceApi.DownloadPictures(noticeOfLossPicture.url);
        const errors: string = this.outboundApi.getModelError().join("; ");
        if (errors) {
            this.showMessageError("Cannot download the selected Picture from the Ftp location.");
        }
        this.overlay = false;
    }

    downloadOutboundNoticeOfLossPictures(noticeOfLossPictures: INoticeOfLossPictures[]) {
        this.overlay = true;
        noticeOfLossPictures.forEach(p => {
            this.uploadServiceApi.DownloadPictures(p.url);
        });
        this.overlay = false;
    }

    @Watch('OutboundNoticeOfLossPictures')
    onChangedOutboundPictures() {
        this.overlay = true;
        this.OutboundNoticeOfLossPictures.forEach(async i => {
            let indexUrl = this.OutboundsBlobsSource.findIndex(b => b.url === i.url);
            if (indexUrl === -1) {
                let blobUrl = await this.uploadServiceApi.DownloadPictures(i.url);
                let blob: IBlob = {} as IBlob;
                blob.id = i.id;
                blob.url = i.url;
                blob.blobUrl = blobUrl;
                blob.noticeOfLossId = this.outboundsSelectedNoticeOfLoss!.id;
                let index = this.OutboundsBlobsSource.findIndex(b => b.id === i.id);
                if (index === -1) {
                    this.OutboundsBlobsSource.push(blob);
                }
            }
        });
        this.overlay = false;
    }

    deleteInboundsNoticeOfLossPicture (item: INoticeOfLossPictures) {
        confirm('Are you sure you want to delete this notice of loss Picture?') && this.deleteInboundsNoticeOfLossPictureItem(item);
    }

    async deleteInboundsNoticeOfLossPictureItem(inboundNoticeOfLossPicture: INoticeOfLossPictures) {
        this.overlay = true;
        let result: boolean = await this.inboundNoticeOfLossPictureApi.DeleteNoticeOfLossPictures(inboundNoticeOfLossPicture.id);
        if (result) {
            let index = this.InboundNoticeOfLossPictures.indexOf(inboundNoticeOfLossPicture);
            this.InboundNoticeOfLossPictures.splice(index, 1);
            let pictureIndex = this.InboundsBlobsSource.findIndex(p => p.url === inboundNoticeOfLossPicture.url);
            this.InboundsBlobsSource.splice(pictureIndex, 1);
            this.showMessageInfo(`The inbound Picture has been successfully deleted`);
        } else {
            const errors: string = this.inboundNoticeOfLossPictureApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async uploadInboundNoticeOfLossPicture(formData : FormData) {
        this.overlay = true;
        let urls: string[] = await this.uploadServiceApi.UploadDocuments(formData);
        for (let i in urls) {
            let inboundNoticeOfLossPicture: INoticeOfLossPictures = {
                id: "",
                url: urls[i],
                urlBlob: "",
                idNoticeOfLoss: this.inboundsSelectedNoticeOfLoss!.id
            };
            const id = await this.inboundNoticeOfLossPictureApi.SaveInboundsNoticeOfLossPictures(inboundNoticeOfLossPicture);
            if (id) {
                inboundNoticeOfLossPicture.id = id;
                inboundNoticeOfLossPicture.urlBlob = await this.uploadServiceApi.DownloadPictures(inboundNoticeOfLossPicture.url);
                this.InboundNoticeOfLossPictures.push(inboundNoticeOfLossPicture);
            } else {
                const errors: string = this.inboundNoticeOfLossPictureApi.getModelError().join("; ");
                this.showMessageError(errors);
            }
        }
        this.showMessageInfo(`The inbound pictures has been successfully saved`);
        this.overlay = false;
    }

    downloadInboundNoticeOfLossPicture(noticeOfLossPicture : INoticeOfLossPictures) {
        this.overlay = true;
        this.uploadServiceApi.DownloadPictures(noticeOfLossPicture.url);
        const errors: string = this.inboundApi.getModelError().join("; ");
        if (errors) {
            this.showMessageError("Cannot download the selected Picture from the Ftp location.");
        }
        this.overlay = false;
    }

    downloadInboundNoticeOfLossPictures(noticeOfLossPictures: INoticeOfLossPictures[]) {
        this.overlay = true;
        noticeOfLossPictures.forEach(p => {
            this.uploadServiceApi.DownloadPictures(p.url);
        });
        this.overlay = false;
    }

    @Watch('InboundNoticeOfLossPictures')
    onChangedInboundPictures() {
        this.overlay = true;
        this.InboundNoticeOfLossPictures.forEach(async i => {
            let indexUrl = this.InboundsBlobsSource.findIndex(b => b.url === i.url);
            if (indexUrl === -1) {
                let blobUrl = await this.uploadServiceApi.DownloadPictures(i.url);
                let blob: IBlob = {} as IBlob;
                blob.id = i.id;
                blob.url = i.url;
                blob.blobUrl = blobUrl;
                blob.noticeOfLossId = this.inboundsSelectedNoticeOfLoss!.id;
                let index = this.InboundsBlobsSource.findIndex(b => b.id === i.id);
                if (index === -1) {
                    this.InboundsBlobsSource.push(blob);
                }
            }
        });
        this.overlay = false;
    }

    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
